import { IntlFormatters } from 'react-intl';

export const getBillingCountryError = (formatMessage: IntlFormatters['formatMessage']) =>
  formatMessage({ id: 'billingCountryIsARequiredField' });
